import React from 'react';
import ClientDetail from '../../components/ClientDetail';
import Clients from './Clients';

const CreateWrapper = (props) => (
  <ClientDetail {...props} actionType="create" />
);
const EditWrapper = (props) => <ClientDetail {...props} actionType="edit" />;

const resource = {
  list: Clients,
  create: CreateWrapper,
  edit: EditWrapper,
};

export default resource;
